import { render, staticRenderFns } from "./sign-in-totp.vue?vue&type=template&id=c6cc0684&scoped=true&"
import script from "./sign-in-totp.vue?vue&type=script&lang=js&"
export * from "./sign-in-totp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cc0684",
  null
  
)

export default component.exports